import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';

var DisabledStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: not-allowed;\n  path {\n    fill: #dee2e6;\n  }\n"], ["\n  cursor: not-allowed;\n  path {\n    fill: #dee2e6;\n  }\n"])));
var StyledDelete = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n\n  &:hover {\n    path {\n      fill: ", ";\n    }\n  }\n\n  ", "\n"], ["\n  cursor: pointer;\n\n  &:hover {\n    path {\n      fill: ", ";\n    }\n  }\n\n  ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    return !disabled && '#212529';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && DisabledStyle;
});
var templateObject_1, templateObject_2;

export { StyledDelete };
